import { AuthSuper } from 'app/components/auth/AuthSuper'
import { useFakeContacts } from 'app/components/fake-contacts/useFakeContacts'
import { FakeContactsShadcnComponent } from 'app/components/fake-contacts/FakeContactsShadcnComponent'

export default function FakeContacts() {
  const hookReturn = useFakeContacts()

  return (
    <AuthSuper>
      <FakeContactsShadcnComponent {...hookReturn} />
    </AuthSuper>
  )
}
